/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import 'core-js/es6/map';
import 'core-js/es6/set';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from "./app/App";

ReactDOM.render(
  <App/>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx